import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, errorText, aiCost } from "@/lib/api";
import { useAdminAuth } from "@/context/AdminAuthContext";

export const PageTitle = ({ eyebrow, title, children }) => (
  <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
    <div>
      {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
      <h1 className="font-display text-4xl font-bold leading-none tracking-tight" style={{ color: "var(--ink)" }}>{title}</h1>
    </div>
    {children}
  </div>
);

export default function AdminOverview() {
  const { admin } = useAdminAuth();
  const [h, setH] = useState(null); const [err, setErr] = useState("");
  useEffect(() => { api.get("/admin/health").then((r) => setH(r.data)).catch((e) => setErr(errorText(e))); }, []);

  const cards = h ? [
    { k: "Subscribers", v: h.subscribers.total, note: `${h.subscribers.core} core · ${h.subscribers.past_due} past due`, to: "/admin/subscribers" },
    { k: "Review queue", v: h.review_queue.pending, note: `oldest waiting ${h.review_queue.oldest_waiting_hours}h`, to: admin.role === "owner" ? "/admin/review-queue" : "/admin/health" },
    { k: "AI cost this month", v: aiCost(h.ai_30d.cost_usd_est, h.ai_30d.calls), note: `${h.ai_30d.calls} calls · ${h.ai_30d.failed} failed`, to: "/admin/health" },
    { k: "Extraction jobs · 7d", v: Object.values(h.extraction_7d).reduce((a, b) => a + b, 0), note: Object.entries(h.extraction_7d).map(([s, n]) => `${n} ${s}`).join(" · ") || "none", to: "/admin/health" },
    { k: "Outbound email · 7d", v: h.email_7d.sent, note: `${h.email_7d.sent} sent · ${h.email_7d.failed} failed · 7 days`, to: ["owner", "support"].includes(admin.role) ? "/admin/emails" : "/admin/health" },
    { k: "Google connections", v: h.google_connections_active, note: "active, read-only", to: "/admin/subscribers" },
  ] : [];

  return (
    <>
      <PageTitle eyebrow="Overview" title={`Welcome, ${admin.full_name || admin.email}`} />
      {err && <p className="ts-error mb-4">{err}</p>}
      {!h ? <p className="text-sm">Loading…</p> : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="overview-cards">
            {cards.map((c) => (
              <Link key={c.k} to={c.to} className="ts-card p-5 block transition-colors hover:bg-[var(--paper)]" data-testid={`overview-card-${c.k.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                <p className="eyebrow">{c.k}</p>
                <p className="num text-3xl mt-2" style={{ color: "var(--ink)" }}>{c.v}</p>
                <p className="text-xs mt-1" style={{ color: "var(--muted-text)" }}>{c.note}</p>
              </Link>
            ))}
          </div>
          <p className="text-xs mt-6" style={{ color: "var(--muted-text)" }}>Real accounts only (test accounts excluded). Each card opens its page.</p>
        </>
      )}
    </>
  );
}
